import { DocumentType } from '../types/DocumentType.enum';

const CPF_LENGTH = 11;
const CNPJ_LENGTH = 14;

const sanitizeAlphanumeric = (document: string): string =>
  document.replace(/[^0-9A-Za-z]/g, '').toUpperCase();

const hasLetters = (document: string): boolean => /[A-Z]/.test(document);

export const formatCPF = (document: string): string =>
  document
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+$/, '$1');

export const formatCNPJ = (document: string): string => {
  const cleaned = sanitizeAlphanumeric(document).slice(0, CNPJ_LENGTH);
  let result = '';
  for (let i = 0; i < cleaned.length; i++) {
    if (i === 2 || i === 5) result += '.';
    if (i === 8) result += '/';
    if (i === 12) result += '-';
    result += cleaned[i];
  }
  return result;
};

export const documentType = (document: string): DocumentType => {
  const cleaned = sanitizeAlphanumeric(document);
  if (hasLetters(cleaned)) return DocumentType.CNPJ;
  return cleaned.length <= CPF_LENGTH ? DocumentType.CPF : DocumentType.CNPJ;
};

export function documentMask(document: string): string {
  return documentType(document) === DocumentType.CPF
    ? formatCPF(document)
    : formatCNPJ(document);
}

export function documentAnonimize(document: string): string {
  const cleaned = document.replace(/[^0-9A-Za-z|*]/g, '').toUpperCase();

  if (!hasLetters(cleaned) && cleaned.length <= CPF_LENGTH) {
    return cleaned.replace(
      /(\d{3}|\*{3})(\d{3})(\d{3})(\d{2}|\*{2})/,
      '***.$2.$3-**',
    );
  }

  return formatCNPJ(cleaned);
}
